export default "__VITE_ASSET__1910f190__"